import React from 'react';
import { useTranslation } from 'react-i18next';

import Dialog from 'components/Dialog';
import { DialogWidth } from 'types';
import ConfirmationPopInContent from './ConfirmationPopInContent';

interface Props {
  title: string;
  isOpen: boolean;
  setOpen: (open: boolean) => void;
  confirmDeletion: () => void;
}

const DeleteConfirmationDialog: React.FC<Props> = ({ title, isOpen, setOpen, confirmDeletion }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      closable={false}
      renderButton={() => {}}
      isOpen={isOpen}
      onClose={(e: React.MouseEvent<EventTarget>) => {
        e.preventDefault();
        setOpen(false);
      }}
      width={DialogWidth.SMALL_FORM}
      renderContent={() => (
        <ConfirmationPopInContent
          title={title}
          cancelText={t('no')}
          validationText={t('yes')}
          cancelAction={(e: React.MouseEvent<EventTarget>) => {
            e.preventDefault();
            setOpen(false);
          }}
          validateAction={confirmDeletion}
        />
      )}
    />
  );
};

export default DeleteConfirmationDialog;
